// Provider IDs occupy one router segment. Legacy alphanumeric IDs are valid too.
export function isInsuranceProviderId(id) {
  return typeof id === 'string' && /^[A-Za-z0-9_-]+$/.test(id);
}

export function warnEmptyInsurance(category, provider, isCurrent) {
  const id = provider && typeof provider === 'object' ? provider.sub_category_id : provider;
  const compulsory = category === 'PC1';
  const location = { name: 'product-insurance-update', params: { id } };
  if (compulsory) location.query = { open: 'act' };
  const href = isInsuranceProviderId(id) ? this.$router.resolve(location).href : null;

  return this.$alertConfirm({
    title: compulsory ? 'ไม่มีสินค้า พ.ร.บ. ที่เปิดใช้งาน' : 'ไม่มีสินค้าประกันภัยที่เปิดใช้งาน',
    confirmButtonText: compulsory ? 'เปิดใช้งานรหัสพ.ร.บ.' : 'ตั้งค่าสินค้าประกันภัย',
    cancelButtonText: 'ปิด',
    showConfirmButton: Boolean(href),
    showCancelButton: true,
    // Run on the confirm gesture so popup blockers do not discard the new tab.
    preConfirm: () => {
      if (href && isCurrent()) window.open(href, '_blank', 'noopener,noreferrer');
    },
  });
}
